import React from 'react';
import Service from '../containers/AllServices/ServicesP';
import Footer from '../containers/Footer/Footer';
  
const Services = () => {
  return (
    <div>
     <Service />
      <Footer />
    </div>
  );
};
  
export default Services;